import React, { useState, useEffect } from "react";
import ListRules from "./rules/ListRules";
import QuestionService from "../../../services/httpServices/question.service";
import {IBlock} from "../../../interfaces/block"

export default function ListSummaries(): JSX.Element {
  const [selectedBlock, setSelectedBlock] = useState<IBlock | null>(null);
  const [blocksList, setBlocksList] = useState<IBlock[]>([]);

  const { getBlocks } = QuestionService();

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const bloques: IBlock[] = await getBlocks();
        const todos: IBlock = {
          name: "Todos",
          includes: bloques.map((block) => block.name),
        };
        bloques.push(todos);
        setBlocksList(bloques);
      } catch (error) {
        console.error("Error fetching blocks:", error);
      }
    };

    fetchBlocks();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value === "") {
      setSelectedBlock(null);
    } else {
      const block = blocksList.find((b) => b.name === value);
      setSelectedBlock(block || null);
    }
  };

  return (
    <div className="container w-[70vw] mx-auto py-6">
      <div className="mb-6">
        <select
          value={selectedBlock?.name || ""}
          onChange={handleChange}
          className="block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:border-blue-300"
        >
          <option value="">--- Selecciona un Bloque ---</option>
          {blocksList.map((block, index) => (
            <option key={index} value={block.name}>
              {block.name}
            </option>
          ))}
        </select>
      </div>
      {selectedBlock && (
        <ListRules block={selectedBlock}/>
      )}
    </div>
  );
}
